
import ChatMessage from "@/platform/chat/model/ChatMessage";
import AttachmentMessage from "@/platform/chat/model/AttachmentMessage";
import ChatRoom from "@/platform/chat/model/ChatRoom";
import { getCurrentChatUserIdentity } from '@/users/services/userService.js'

const TWILIO_MESSAGE_TYPE_TEXT = "text"
const TWILIO_MESSAGE_TYPE_ATTACHMENT = "media"


// IMPORTANT! Avoid attaching room to message and thu needing to use the transformChannelToRoom() method!
const transformMessageToChatMessage = async (tMessage) => {
    var authorMember = await tMessage.getMember()
    console.log('transformMessageToChatMessage > tMessage:', tMessage);
    
    if (tMessage.type == TWILIO_MESSAGE_TYPE_TEXT) {
        return new ChatMessage({
            id: tMessage.sid,
            textMessage: tMessage.body,
            roomId: tMessage.channel.sid,
            roomLastConsumedMessageIndex: tMessage.channel.lastConsumedMessageIndex,
            // room: await transformChannelToRoom(tMessage.channel),
            timestamp: tMessage.dateCreated,
            msgType: tMessage.type,
            authorSid: tMessage.memberSid,
            authorIdentity: authorMember.identity,
            index: tMessage.index,
            attributes: tMessage.attributes,
            author: tMessage.author
        })
    }
    else if (tMessage.type == TWILIO_MESSAGE_TYPE_ATTACHMENT) {
        return new AttachmentMessage({
            id: tMessage.sid,
            textMessage: tMessage.body,
            roomId: tMessage.channel.sid,
            roomLastConsumedMessageIndex: tMessage.channel.lastConsumedMessageIndex,
            // room: await transformChannelToRoom(tMessage.channel),
            timestamp: tMessage.dateCreated,
            msgType: tMessage.type,
            authorSid: tMessage.memberSid,
            attachment: tMessage.media,
            authorIdentity: authorMember.identity,
            index: tMessage.index,
            attributes: tMessage.attributes,
            author: tMessage.author
        })
    }
    else throw Error("twilio message type unknown")
}

const transformChannelToRoom = async (channel) => {
    try {
        var members = await channel.getMembers()
        // IMPORTANT! as being part of chat init, chat user id  will be promised to be set before this is ever reached.
        var currentUserIdentity = await getCurrentChatUserIdentity()


        var attributes = {}
        if(channel.attributes) attributes = channel.attributes
        attributes.memberUids = []

        var otherMember
        for (let i = 0, n = members.length; i < n; i++) {
            const member = members[i];
            attributes.memberUids.push(member.identity)
            if (member.identity != currentUserIdentity) {   // compare to current user uid
                otherMember = member
                break;
            }
        }

        var otherMemberAdapted = {}
        if (otherMember) {
            var userDesc = await otherMember.getUserDescriptor()
            otherMemberAdapted.name = userDesc.friendlyName
            otherMemberAdapted.avatarURL = userDesc.attributes.avatarURL
            otherMemberAdapted.maaklerId = userDesc.attributes.maaklerId

            //Note that online and notifiable properties are eligible to use only if reachability function is enabled. You may check if it is enabled by reading value of Client's reachabilityEnabled property.
            otherMemberAdapted.isOnline = userDesc.online
            otherMemberAdapted.identity = otherMember.identity
        }

        var lastMessage;
        if (channel.lastMessage) {
            lastMessage = {
                index: channel.lastMessage.index,
                timestamp: channel.lastMessage.dateCreated,
            };
        }

        var room = new ChatRoom({
            id: channel.sid,
            avatarURL: otherMemberAdapted.avatarURL,
            name: channel.friendlyName,
            users: members,
            displayName: getRoomDisplayName(otherMemberAdapted, channel),
            otherMember: otherMemberAdapted,
            lastMessage: lastMessage,
            lastConsumedMessageIndex: channel.lastConsumedMessageIndex,
            archived: false,
            unseenMsg: false,
            attributes: attributes,
            channel: channel
        });
        return room;

    } catch (err) {
        console.log('twilioTransformer | transformChannelToRoom > err:', err);
        return false
    }
}

function getRoomDisplayName(otherMember, channel) {
    try {
        if (otherMember.name) return otherMember.name
    } catch (err) {

    }
    return channel.friendlyName
}

export { transformChannelToRoom, transformMessageToChatMessage }


// WEBPACK FOOTER //
// ./src/third-party/twilio/chat/transformers/twilioImportTransformer.js